import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export function BankAccountDialog({ open, onOpenChange, bank, onSaved }) {
  const [f, setF] = useState({ bank_name: "", account_holder: "", iban: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) { setF({ bank_name: bank?.bank_name || "", account_holder: bank?.account_holder || "", iban: bank?.iban || "" }); }
  }, [open, bank]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/my/bank", f);
      toast.success("تم حفظ بيانات الحساب البنكي");
      onSaved(data); onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl" data-testid="bank-dialog">
        <DialogHeader><DialogTitle>الحساب البنكي لاستلام المستحقات</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>اسم البنك</Label><Input value={f.bank_name} onChange={set("bank_name")} maxLength={80} placeholder="مثال: مصرف الراجحي" data-testid="bank-name-input" /></div>
          <div><Label>اسم صاحب الحساب</Label><Input value={f.account_holder} onChange={set("account_holder")} maxLength={120} data-testid="bank-holder-input" /></div>
          <div><Label>رقم الآيبان</Label><Input dir="ltr" value={f.iban} onChange={set("iban")} maxLength={40} placeholder="SA0000000000000000000000" className="font-mono" data-testid="bank-iban-input" /></div>
          <p className="text-xs text-muted-foreground">تأكد أن الحساب باسم الورشة أو مقدم الخدمة، فالتحويلات تتم على هذا الآيبان.</p>
        </div>
        <DialogFooter>
          <Button className="w-full rounded-xl gap-2" disabled={busy} onClick={save} data-testid="bank-save-btn">{busy && <Loader2 className="w-4 h-4 animate-spin" />} حفظ</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
